// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5K-MT","toggle":"styles_toggle__poO9K","preview":"styles_preview__3Vwgm"};